/**
 * O aviso de que a lista está cortada.
 *
 * As listas em tela cheia da interna pedem uma página só (`page: 1,
 * perPage: 50`) e **não paginam** — mas o cabeçalho anuncia o `total` que o
 * servidor devolveu. Numa base com 120 pessoas, o cartão dizia **"120 pessoas"**
 * sobre 50 linhas, sem nada indicando o corte: quem procurava alguém que ordena
 * em 51º concluía que a pessoa não tem vínculo com a base.
 *
 * Enquanto elas não paginam, a tela diz o que ela de fato mostra. Devolve
 * `undefined` quando não há corte, para o cartão não ganhar uma linha à toa.
 *
 * **Desde 10/09 existe um paginador** (`components/Pagination.tsx`), e ele
 * nasceu no modal de vendas do ranking — onde este aviso não serve, porque não
 * há filtro ao lado para "chegar ao resto" e as linhas são a resposta inteira
 * que o modal foi aberto para dar.
 *
 * **Em 11/09 a primeira tela cheia trocou o aviso pelo paginador**: a lista de
 * vendas (`modules/sales/SalesScreen.tsx`), que passou a pedir dez linhas e a
 * deixar a pessoa escolher quantas quer. As outras seis continuam aqui, e
 * trocá-las é decisão de cada uma — onde a busca chega ao registro procurado em
 * uma digitação, virar página é o pior dos dois caminhos.
 */
export function truncationNotice(
  total: number | undefined,
  shown: number,
): string | undefined {
  if (total === undefined || total <= shown) return undefined;
  return `Mostrando ${shown} de ${total}. Use a busca e os filtros para chegar ao resto.`;
}
